// extracted by mini-css-extract-plugin
module.exports = {"Blogposts":"Blogposts_Blogposts__OjD8U","Link":"Blogposts_Link__DpJ7m"};